import { Mock } from 'ts-mockery';
import { UserTrackingService } from '../user-tracking.service';

export const getMockUserTrackingService = () =>
  Mock.of<UserTrackingService>({
    initialize: async () => undefined,
    identify: async () => undefined,
    track: async () => undefined,
    page: async () => undefined,
  });

export const provideMockUserTrackingService = () => ({
  provide: UserTrackingService,
  useFactory: getMockUserTrackingService,
});
